import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';
import { useQuery } from 'react-query';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

export default function Usegetreviewsfromsettings(id) {
  return useQuery(['reviews-from-settings', id], async () => {
    const response = await makeApiRequest.get(
      createQueryParamsForGetReq(apiEndPoints.SETTINGS_REVIEW_TYPES, {
        id: id,
      })
    );

    return response.data;
  });
}
